<template>
  <div :style="fullscreen ? fullStyle : null">
    <div v-if="showFilters" class="col-12 d-flex align-center justify-center">
      <v-autocomplete v-model="filtros.idMaquinaIns" :items="instancias" :item-text="nombreMaquina"
        item-value="idMaquinaIns" label="Máquina Instancia" hide-details clearable :loading="loadingInstancias"
        :disabled="loading || uiLocked" @change="obtenerDatos" />

      <datePicker v-model="filtros.fecha" format="YYYY-MM-DD" label="Fecha" clearable
        :class="loading && 'disabled-input'" :disabled="loading || uiLocked" maxToday @input="obtenerDatos" class="mx-2" />

      <v-autocomplete v-model="filtros.turno" label="Turno" :items="turnos" item-text="nombre" item-value="idTurno"
        clearable :loading="loadingTurnos" :disabled="loading || uiLocked" @change="obtenerDatos"></v-autocomplete>
    </div>
    <!-- Solo visible en la pestaña de GráficaFiltros -->
    <div v-if="modoDatos === 'GraficaFiltros'" class="d-flex align-center my-2 gf-filtros lockable">
      <!-- Inicio: viene del filtro general -->
      <v-chip class="mx-2" label color="blue lighten-5" text-color="blue darken-2">
        Inicio: {{ gf.desde || '—' }}
      </v-chip>

      <!-- Fin: único datepicker activo -->
      <datePicker
        v-model="gf.hasta"
        format="YYYY-MM-DD"
        label="Hasta (fin del rango)"
        :disabled="uiLocked || !gf.desde"
        :min="gf.desde || undefined"
        maxToday
        class="mx-2"
        @input="onHastaChanged"
      />

      <!-- Multi selección de máquinas -->
      <v-autocomplete
        v-model="gf.idMaquinasIns"
        :items="instancias"
        :item-text="nombreMaquina"
        item-value="idMaquinaIns"
        label="Máquinas"
        multiple
        chips
        clearable
        :loading="loadingInstancias"
        :disabled="uiLocked"
        class="mx-2"
      />

      <v-autocomplete
        v-model="gf.agruparPor"
        :items="[{text:'Por máquina',value:'maquina'},{text:'Por área',value:'area'},{text:'Por día',value:'dia'}]"
        item-text="text" item-value="value"
        label="Agrupar por"
        :disabled="uiLocked"
        class="mx-2"
      />
      <v-spacer/>
      <v-switch v-model="sinDisponibilidad" label="Sin Disponibilidad" hide-details class="mx-2" :disabled="uiLocked"/>
      <v-switch v-model="desConParosNP" label="Desc. Paros NP" hide-details class="mx-2" :disabled="uiLocked"/>
      <div v-if="uiLocked" class="ui-lock-overlay"></div>
    </div>
    <div class="text-subtitle-1 font-weight-medium">
      <div v-if="fullscreen" class="d-flex justify-end">
        <v-btn text color="primary" @click="$emit('close')">
          <v-icon left>mdi-keyboard-return</v-icon> Cerrar Vista
        </v-btn>
      </div>
    </div>
    <v-row v-if="(Object.keys(response).length > 0 && loading != true) || modoDatos === 'GraficaFiltros'">
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <div class="d-flex align-center mb-3">
              <div class="rounded-pill grey lighten-4 pa-1 d-inline-flex elevation-1">
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                      :color="modoDatos === 'Tabla' ? 'primary' : 'blue lighten-5'" :aria-pressed="modoDatos === 'Tabla'"
                      @click="modoDatos = 'Tabla'">
                      <v-icon small :color="modoDatos === 'Tabla' ? 'white' : 'blue darken-2'">mdi-table-large</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text">Tabla</span>
                </v-tooltip>
                <v-tooltip bottom color="black">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" small fab class="mx-1"
                      :color="modoDatos === 'Grafica' ? 'primary' : 'blue lighten-5'"
                      :aria-pressed="modoDatos === 'Grafica'" @click="modoDatos = 'Grafica'">
                      <v-icon small
                        :color="modoDatos === 'Grafica' ? 'white' : 'blue darken-2'">mdi-chart-bar</v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text">Gráfica</span>
                </v-tooltip>
                <!--<v-tooltip bottom color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs" v-on="on" small fab class="mx-1"
                    :color="modoDatos === 'GraficaFiltros' ? 'primary' : 'blue lighten-5'"
                    :aria-pressed="modoDatos === 'GraficaFiltros'"
                    :aria-label="`Ver gráfica ( ${filtrosActivos} filtros )`"
                    @click="modoDatos = 'GraficaFiltros'"
                  >
                    opcional: badge con cantidad de filtros
                    <v-badge :content="filtrosActivos" :value="filtrosActivos > 0" overlap>
                      <v-icon small :color="modoDatos === 'GraficaFiltros' ? 'white' : 'blue darken-2'">
                        mdi-chart-box-plus-outline
                      </v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <div class="white--text">
                  Gráfica ({{ filtrosActivos }} {{ filtrosActivos === 1 ? 'filtro' : 'filtros' }})
                </div>
              </v-tooltip>-->
              </div>
              <div class="rounded-pill blue-grey lighten-5 pa-1 d-inline-flex elevation-1 ml-5">
                <v-tooltip bottom color="blue-grey darken-4">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on" small fab class="mx-1"
                      :color="modoGrupo === 'articulos' ? 'deep-purple darken-2' : 'deep-purple lighten-5'"
                      :aria-pressed="modoGrupo === 'articulos'"
                      @click="modoGrupo = 'articulos'"
                    >
                      <v-icon small :color="modoGrupo === 'articulos' ? 'white' : 'deep-purple darken-2'">
                        mdi-cog-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text">Por artículo</span>
                </v-tooltip>

                <v-tooltip bottom color="blue-grey darken-4">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs" v-on="on" small fab class="mx-1"
                      :color="modoGrupo === 'cavidades' ? 'teal darken-2' : 'teal lighten-5'"
                      :aria-pressed="modoGrupo === 'cavidades'"
                      @click="modoGrupo = 'cavidades'"
                    >
                      <v-icon small :color="modoGrupo === 'cavidades' ? 'white' : 'teal darken-2'">
                        mdi-robot-industrial
                      </v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text">Por cavidad</span>
                </v-tooltip>
              </div>
              <v-spacer></v-spacer>
              <DownloadBtn text color="primary" className="my-0" @click="descargarReporte()" label="Descargar Reporte"/>
              <div class="text-subtitle-2">Proxima Actualización en {{ timeFormatted }}</div>
            </div>
            <v-tabs-items v-model="modoDatos">
            <v-tab-item value="Tabla">
              <v-card flat>
                <HoraPorHoraTabla v-model="response" :agruparPor="modoGrupo"/>
              </v-card>
            </v-tab-item>

              <v-tab-item value="Grafica">
                <v-card flat>
                  <HoraPorHoraGrafica 
                    v-model="response" 
                    :agruparPor="modoGrupo" 
                    :mostrar-siempre-nombre-art="nombreArt"
                    :id-maquina-ins="filtros.idMaquinaIns"
                    :fecha="filtros.fecha"
                    :turno-seleccionado="turnoSeleccionado"
                    :maquina-seleccionada-nombre="maquinaSeleccionadaNombre"
                  />
                </v-card>
              </v-tab-item>

            <!-- arriba de la gráfica -->
            <!--<div v-if="lpLoading" class="mb-2">
              <v-progress-linear
                :indeterminate="!lpProgress.total"
                :value="lpProgress.total ? (lpProgress.done / lpProgress.total) * 100 : 0"
                height="4"
              />
              <small class="grey--text text--darken-1 d-block mt-1">
                Procesando {{ lpProgress.done }}/{{ lpProgress.total || '—' }}
              </small>
            </div>
            <v-tab-item value="GraficaFiltros">
              dentro del <v-tab-item value="GraficaFiltros"> -->
                <!-- === SOLO EN GRAFICA FILTROS: KPIs OEE arriba ===
                <v-row dense class="mb-3">
                  <v-col cols="3"><v-card outlined class="kpi-card pa-4 d-flex align-center">
                    <v-avatar color="#3949AB" size="36" class="mr-3"><v-icon color="white">mdi-chart-bar-stacked</v-icon></v-avatar>
                    <div><div class="caption text-uppercase grey--text text--darken-1">OEE</div>
                      <div class="headline font-weight-bold">{{ pf(kpisActuales.oee) }}</div></div>
                  </v-card></v-col>

                  <v-col cols="3"><v-card outlined class="kpi-card pa-4 d-flex align-center">
                    <v-avatar color="#F4511E" size="36" class="mr-3"><v-icon color="white">mdi-clock-outline</v-icon></v-avatar>
                    <div><div class="caption text-uppercase grey--text text--darken-1">Disponibilidad</div>
                      <div class="headline font-weight-bold">{{ pf(kpisActuales.disp) }}</div></div>
                  </v-card></v-col>

                  <v-col cols="3"><v-card outlined class="kpi-card pa-4 d-flex align-center">
                    <v-avatar color="#00796B" size="36" class="mr-3"><v-icon color="white">mdi-run</v-icon></v-avatar>
                    <div><div class="caption text-uppercase grey--text text--darken-1">Rendimiento</div>
                      <div class="headline font-weight-bold">{{ pf(kpisActuales.rend) }}</div></div>
                  </v-card></v-col>

                  <v-col cols="3"><v-card outlined class="kpi-card pa-4 d-flex align-center">
                    <v-avatar color="#7CB342" size="36" class="mr-3"><v-icon color="white">mdi-star-circle-outline</v-icon></v-avatar>
                    <div><div class="caption text-uppercase grey--text text--darken-1">Calidad</div>
                      <div class="headline font-weight-bold">{{ pf(kpisActuales.cali) }}</div></div>
                  </v-card></v-col>
                </v-row>
              <v-card flat>
              Contenedor relativo para anclar el panel derecho
              <div class="apex-wrap apex-zone">
                LA GRÁFICA (queda del mismo tamaño)
                <HoraPorHoraGrafica
                  :key="`gf-${gf.desde}-${gf.hasta}-${gf.agruparPor}-` +
                  `${(gf.idMaquinasIns||[]).join('_')}-` +
                  `${(gf.idAreas||[]).join('_')}-` +
                  `${sinDisponibilidad?1:0}-${desConParosNP?1:0}`"
                  v-model="response"
                  :agruparPor="modoGrupo"
                  :mostrar-siempre-nombre-art="nombreArt"
                  modo="dias"
                  :fuente="gfDataNormalizada"
                  :gf-rows="gf.agruparPor === 'dia' ? gfData : []"
                  :mostrar-total="gf.agruparPor === 'dia'"
                  :show-side-kpis="false"
                />

                PANEL DERECHO 2x2 (solo desktop/tablet)
                <div class="side-kpis d-none d-md-block">
                  <v-row dense>
                    <v-col cols="6">
                      <v-card outlined class="pa-3">
                        <div class="caption text-uppercase grey--text text--darken-1">Piezas esperadas</div>
                        <div class="title font-weight-bold">{{ nf(kpisActuales.esperadas) }}</div>
                        <div class="kpi-sub">Total del periodo</div>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card outlined class="pa-3">
                        <div class="caption text-uppercase grey--text text--darken-1">Piezas OK</div>
                        <div class="title font-weight-bold">{{ nf(kpisActuales.ok) }}</div>
                        <div class="kpi-sub">Total del periodo</div>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card outlined class="pa-3">
                        <div class="caption text-uppercase grey--text text--darken-1">Piezas NO OK</div>
                        <div class="title font-weight-bold">{{ nf(kpisActuales.noOk) }}</div>
                        <div class="kpi-sub">Total del periodo</div>
                      </v-card>
                    </v-col>
                    <v-col cols="6">
                      <v-card outlined class="pa-3">
                        <div class="caption text-uppercase grey--text text--darken-1">Diferencia (Delta)</div>
                        <div
                          class="title font-weight-bold d-flex align-center"
                          :class="kpisActuales.delta < 0 ? 'neg' : kpisActuales.delta > 0 ? 'pos' : ''"
                        >
                          <v-icon small class="mr-1" v-if="kpisActuales.delta !== 0"
                                  :color="kpisActuales.delta < 0 ? '#E53935' : '#2E7D32'">
                            {{ kpisActuales.delta < 0 ? 'mdi-menu-down' : 'mdi-menu-up' }}
                          </v-icon>
                          {{ nf(kpisActuales.delta) }}
                        </div>
                        <div class="kpi-sub">vs plan (Total del periodo)</div>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
                <v-col col="12">
                  <OeePorDiaMaquina :rows="gfData" :sin-disponibilidad="sinDisponibilidad" estrategia="grafica"/>
                </v-col>
                <v-col cols="12">
                  <OeeBarPorMaquina :rows="gfData" :incluirCeros="false"/>
                </v-col>

                <div v-if="uiLocked" class="click-blocker"></div>
              </div>
            </v-card>

            <v-row dense class="mt-4 d-md-none">
              <v-col cols="6"><v-card outlined class="pa-3">
                <div class="caption text-uppercase grey--text text--darken-1">Piezas esperadas</div>
                <div class="title font-weight-bold">{{ nf(kpisActuales.esperadas) }}</div>
                <div class="kpi-sub">Total del periodo</div>
              </v-card></v-col>

              <v-col cols="6"><v-card outlined class="pa-3">
                <div class="caption text-uppercase grey--text text--darken-1">Piezas OK</div>
                <div class="title font-weight-bold">{{ nf(kpisActuales.ok) }}</div>
                <div class="kpi-sub">Total del periodo</div>
              </v-card></v-col>

              <v-col cols="6"><v-card outlined class="pa-3">
                <div class="caption text-uppercase grey--text text--darken-1">Piezas NO OK</div>
                <div class="title font-weight-bold">{{ nf(kpisActuales.noOk) }}</div>
                <div class="kpi-sub">Total del periodo</div>
              </v-card></v-col>

              <v-col cols="6"><v-card outlined class="pa-3">
                <div class="caption text-uppercase grey--text text--darken-1">Diferencia (Delta)</div>
                <div class="title font-weight-bold d-flex align-center"
                    :class="kpisActuales.delta < 0 ? 'neg' : kpisActuales.delta > 0 ? 'pos' : ''">
                  <v-icon small class="mr-1" v-if="kpisActuales.delta !== 0"
                          :color="kpisActuales.delta < 0 ? '#E53935' : '#2E7D32'">
                    {{ kpisActuales.delta < 0 ? 'mdi-menu-down' : 'mdi-menu-up' }}
                  </v-icon>
                  {{ nf(kpisActuales.delta) }}
                </div>
                <div class="kpi-sub">vs plan (Total del periodo)</div>
              </v-card></v-col>
            </v-row>
          </v-tab-item>-->
          </v-tabs-items>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-col cols="12">
      <v-col v-if="loading" cols="12" class="text-center">
        <v-progress-circular :size="70" :width="7" color="green" indeterminate></v-progress-circular>
        <h2>Cargando...</h2>
      </v-col>
      <v-col cols="12" v-else-if="!loading && Object.keys(response).length == 0">
        <v-alert color="blue-grey" text class="mb-0">
          <div class="text-center" style="font-size: 16px">
            Debe de Seleccionar Maquina, Fecha y Turno
          </div>
        </v-alert>
      </v-col>
    </v-col>
  </div>
</template>

<script>
import { mapState } from 'vuex/dist/vuex.common.js';
import HoraPorHoraTabla from './HoraPorHoraTabla.vue';
import HoraPorHoraGrafica from './HoraPorHoraGrafica.vue';
import OeePorDiaMaquina from './OeePorDiaMaquina.vue';
import OeeBarPorMaquina from './OeeBarPorMaquina.vue';
import moment from "moment";
import DownloadBtn from '../../../DownloadBtn.vue';

import axios from 'axios';

export default {
  components: {
    HoraPorHoraTabla,
    HoraPorHoraGrafica,
    OeePorDiaMaquina,
    OeeBarPorMaquina,
    DownloadBtn,
  },
  data() {
    const minutesDefault = 5
    const totalMs = minutesDefault * 60 * 1000

    return {
      gfCache: new Map(),  // fecha(YYYY-MM-DD) -> rows normalizadas POR MÁQUINA
      instById: new Map(), // índice para saber el área de una máquina
      lpAbort: null,        // AbortController para cancelar la corrida
      lpLoading: false,     // loading del long-poll
      lpProgress: { done: 0, total: 0 }, // opcional para mostrar avance
      gfData: [],          // registros normalizados (ver método)
      gfDias: [],          // categorías (YYYY-MM-DD)
      gfSeries: [],        // series para apex
      areas: [],
      loadingAreas: false,
      filtros: {
        idMaquinaIns: null,
        fecha: null,
        turno: null,
      },
      gf: {
        idAreas: [],
        idMaquinasIns: [],
        desde: null,
        hasta: null,
        agruparPor: 'dia',   // 'maquina' | 'area'
      },
      gfHastaTouched: false,
      loadingGF: false,
      modoDatos: "Tabla",
      modoGrupo: "cavidades", // 'cavidades' | 'articulos'
      nombreArt: true,
      sinDisponibilidad: false,
      desConParosNP: true,

      instancias: [],
      turnos: [],
      response: [],

      loading: false,
      loadingInstancias: false,
      loadingTurnos: false,

      minutes: minutesDefault,
      totalMs,
      remainingMs: totalMs,
      isRunning: false,
      intervalId: null,
      endAt: null,
      espOcultas: false,
    }
  },

  props: {
    fullscreen: { type: Boolean, default: false },
    showFilters: { type: Boolean, default: true },
    modo: { type: String, default: 'horas' },            // 'horas' | 'dias'
    fuente: { type: Object, default: null },             // { dias:[{fecha, grupos:[...]}], resumen:{...} }
  },

  computed: {
    uiLocked () { return this.lpLoading || this.loadingGF; },
    gfDataNormalizada () {
      // --- Por día: producir grupos por turno (A,P,Q ponderados por 'teoricas') ---
      if (this.gf.agruparPor === 'dia') {
        // mapa: fecha -> turnoId -> acumuladores
        const acc = new Map(); // fecha -> Map(turnoId -> { nombre, teo, A, P, Q })
        for (const r of (this.gfData || [])) {
          const fecha = (r.fecha || '').slice(0,10);
          if (!fecha) continue;
          const turnoId = r.turnoId ?? null;
          const turnoNombre = r.turnoNombre ?? (turnoId != null ? `Turno ${turnoId}` : 'Total');

          if (!acc.has(fecha)) acc.set(fecha, new Map());
          const byTurno = acc.get(fecha);
          if (!byTurno.has(turnoId)) byTurno.set(turnoId, { nombre: turnoNombre, teo:0, A:0, P:0, Q:0 });

          const teo = Number(r.teoricas || 0);
          const A   = Number(r.disponibilidad || 0);
          const P   = Number(r.rendimiento    || 0);
          const Q   = Number(r.calidad        || 0);

          const t = byTurno.get(turnoId);
          t.teo += teo;
          t.A   += A * teo;
          t.P   += P * teo;
          t.Q   += Q * teo;
        }

        // construir { dias:[{fecha, grupos:[{id,label,teoricas,A,P,Q}]}], resumen:{...} }
        const dias = Array.from(acc.entries())
          .sort(([a],[b]) => a.localeCompare(b))
          .map(([fecha, byTurno]) => {
            const grupos = Array.from(byTurno.entries()).map(([turnoId, v]) => {
              const teo = v.teo || 0;
              const A = teo ? v.A / teo : 0;
              const P = teo ? v.P / teo : 0;
              const Q = teo ? v.Q / teo : 0;
              return {
                id: String(turnoId ?? 'total'),
                label: v.nombre,
                ok: 0,
                teoricas: teo,
                A, P, Q,
                disponibilidad: A,
                rendimiento: P,
                calidad: Q,
              };
            });
            // orden opcional por id de turno (null al final)
            grupos.sort((a,b) => {
              const ai = a.id === 'total' ? Number.MAX_SAFE_INTEGER : +a.id;
              const bi = b.id === 'total' ? Number.MAX_SAFE_INTEGER : +b.id;
              return ai - bi;
            });
            return { fecha, grupos };
          });

        return { dias, resumen: this.resumenGF };
      }

      // ---- comportamiento normal (por máquina/área) ----
      const map = new Map();
      for (const r of (this.gfData || [])) {
        const fecha = (r.fecha || 'Total').slice(0,10);
        if (!map.has(fecha)) map.set(fecha, []);
        map.get(fecha).push({
          id:  r.key ?? r.id ?? r.label ?? '—',
          label: r.label ?? r.nombre ?? r.maquina ?? r.area ?? '—',
          ok:  Number(r.ok || 0),
          teoricas: Number(r.teoricas || r.teo || 0),
          A:   Number(r.disponibilidad ?? r.A ?? 0),
          P:   Number(r.rendimiento    ?? r.P ?? 0),
          Q:   Number(r.calidad        ?? r.Q ?? 0),
        });
      }
      const dias = Array.from(map.entries())
        .sort(([a],[b]) => a.localeCompare(b))
        .map(([fecha, grupos]) => ({ fecha, grupos }));
      return { dias, resumen: this.resumenGF };
    },
    gfOeePorDia () {
      // agrupa this.gfData por fecha y calcula A,P,Q ponderados por 'teoricas'
      const porDia = new Map();
      for (const r of (this.gfData || [])) {
        const f = (r.fecha || '').slice(0,10);
        if (!f) continue;
        if (!porDia.has(f)) porDia.set(f, {teo:0, A:0, P:0, Q:0});
        const row = porDia.get(f);
        const teo = Number(r.teoricas||0);
        row.teo += teo;
        row.A   += (Number(r.disponibilidad||0) * teo);
        row.P   += (Number(r.rendimiento||0)    * teo);
        row.Q   += (Number(r.calidad||0)        * teo);
      }
      // devuelve [{fecha, oee, A,P,Q}]
      return Array.from(porDia.entries())
        .sort(([a],[b])=>a.localeCompare(b))
        .map(([fecha, v]) => {
          const A = v.teo ? v.A / v.teo : 0;
          const P = v.teo ? v.P / v.teo : 0;
          const Q = v.teo ? v.Q / v.teo : 0;
          const oee = this.sinDisponibilidad ? (P * Q) / 100 : (A * P * Q) / 10000;
          return { fecha, A, P, Q, oee };
        });
    },
    _seriesDias() {
      if (this.modo !== 'dias') return [];

      const dias = this._rowsPeriodo; // [{fecha, grupos:[{ id,label, ok, teoricas, A,P,Q }]}]
      const cats = this._categoriasX;

      // 4.1 juntar todas las entidades (áreas/máquinas) que aparezcan
      const entidades = Array.from(
        new Set(dias.flatMap(d => (d.grupos||[]).map(g => g.label || g.nombre || g.id)))
      );

      // 4.2 barras: OEE por entidad y día (A*P*Q/10000)
      const seriesBarras = entidades.map((lbl, idx) => ({
        name: lbl,
        type: 'column',
        data: cats.map(f => {
          const d = dias.find(x => x.fecha === f);
          const g = (d?.grupos || []).find(x => (x.label||x.nombre||x.id) === lbl);
          if (!g) return 0;
          const A = Number(g.A ?? g.disponibilidad ?? 0);
          const P = Number(g.P ?? g.rendimiento    ?? 0);
          const Q = Number(g.Q ?? g.calidad        ?? 0);
          const oee = (g.oee != null) ? Number(g.oee) : (A * P * Q) / 10000;
          return oee;
        }),
        color: this.paletteBars[idx % this.paletteBars.length],
      }));

      // 4.3 línea: OEE total ponderado por teóricas por día
      const serieLinea = {
        name: 'OEE total',
        type: 'line',
        data: cats.map(f => {
          const d = dias.find(x => x.fecha === f) || {};
          const gs = d.grupos || [];
          const teo = gs.reduce((s,g)=> s + Number(g.teoricas ?? 0), 0);
          if (!teo) return 0;
          const w = k => gs.reduce((s,g)=> s + Number((g[k]??g[k?.toUpperCase?.()]??0)) * Number(g.teoricas??0),0)/teo;
          const A = w('disponibilidad'), P = w('rendimiento'), Q = w('calidad');
          return (A * P * Q) / 10000;
        })
      };

      return [...seriesBarras, serieLinea];
    },
    horaHoraOpts() {
      const usandoDias = (this.modo === 'dias');
      const nCols = usandoDias ? (this._seriesDias.filter(s=>s.type==='column').length) :
                                (((this.agruparPor||'').toLowerCase()==='articulos') ? this._articulosSerie.length : this._cavidadesActivas.length);
      const nLineas = usandoDias ? 1 : /* lo que ya calculas */  (this._articulosSerie.length + (this.mostrarEsperadasTotal?1:0));
      const metaOEE = 85; // % objetivo. Podrías moverlo a prop o a Vuex por empresa
      return {
        chart: { type: 'line', height: 500, toolbar: { show: true } },
        xaxis: { categories: this._categoriasX, labels: { rotate: -35, rotateAlways: true, style:{fontSize:'11px'}, minHeight:58, maxHeight:58, offsetY:6 } },
        legend: { show: true, position: 'top' },
        plotOptions: { bar: { columnWidth: '40%', borderRadius: 4 }, dataLabels: { position: 'top' } },
        stroke: {
          width: Array(nCols).fill(0).concat(Array(nLineas).fill(3)),
          curve: 'smooth',
          dashArray: Array(nCols).fill(0).concat([5]) // línea total punteada si quieres
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [...Array.from({length:nCols},(_,i)=>i)],
          formatter: v => `${Math.round(Number(v)||0)}%`,
          offsetY: -8,
          style: { fontSize: '11px' }
        },
        annotations: usandoDias ? {
        yaxis: [{
          y: metaOEE,
          borderColor: '#90A4AE',
          label: { text: `Meta ${metaOEE}%`, style:{ fontSize:'11px', background:'#90A4AE' } }
          }]
        } : {},
        yaxis: [{ max:100, min:0, tickAmount:5, labels:{ formatter:v=>`${v}%` }, title:{ text:'OEE (%)' } }],
        tooltip: { shared:true, intersect:false },
        markers: { size: Array(nCols).fill(0).concat([4]) }
      };
    },
    // Categorías (días) para el eje X — si no viene 'fecha' desde el back, usamos 'Total'
    gfDiasCats () {
      if (this.gf.agruparPor === 'dia') {
        return this.gfOeePorDia.map(d => d.fecha)     // 👈 solo fechas
      }
      if (!this.gfData?.length) return []
      return Array.from(new Set(this.gfData.map(x => x.fecha).filter(Boolean))).sort()
    },
    _rowsPeriodo() {
      // prioridad: si te pasaron `fuente` úsala; si no, toma this.value
      const src = this.fuente || this.value || {};
      if (this.modo === 'dias') {
        // Espera formato: { dias:[{ fecha:'YYYY-MM-DD', grupos:[{ id, label, ok, teoricas, A,P,Q }] }], resumen:{...} }
        return Array.isArray(src.dias) ? src.dias : [];
      }
      // fallback actual por horas
      const data = src?.horas ?? src ?? [];
      return Array.isArray(data) ? data : [];
    },

    _categoriasX() {
      if (this.modo === 'dias') {
        return this._rowsPeriodo.map(d => d.fecha).filter(Boolean);
      }
      // lo que hacías antes (horas)
      const rows = this._rowsHora;         // <- si mantienes compatibilidad
      const seen = new Set(); const cats = [];
      rows.forEach(r => {
        const desde = r.desdeHora ?? r.horaInicio;
        const hasta = r.hastaHora ?? r.horaFin;
        if (desde && hasta) {
          const label = `${desde} - ${hasta}`;
          if (!seen.has(label)) { seen.add(label); cats.push(label); }
        }
      });
      return cats;
    },
    // Series para Apex con barras agrupadas por día + una línea con OEE total
    chartSeriesGF () {
      if (this.gf.agruparPor === 'dia') {
        const turnosUnicos = Array.from(new Set((this.gfData||[])
          .map(r => r.turnoId)
          .filter(t => t != null)));

        const nombreTurno = (id) =>
          (this.gfData.find(r => r.turnoId === id)?.turnoNombre) || `Turno ${id}`;

        const oeeDiaTurno = (fecha, turnoId) => {
          const rows = (this.gfData||[]).filter(r =>
            r.fecha === fecha && (turnoId == null ? true : r.turnoId === turnoId));
          const teo = rows.reduce((s,r)=> s + Number(r.teoricas||0), 0);
          if (!teo) return 0;
          const w = k => rows.reduce((s,r)=> s + Number(r[k]||0) * Number(r.teoricas||0), 0) / teo;
          const A = w('disponibilidad'), P = w('rendimiento'), Q = w('calidad');
          const oee = this.sinDisponibilidad ? (P*Q)/100 : (A*P*Q)/10000;
          return this._roundPct(oee, 2); // ⬅️ sin decimales
        };

        const series = turnosUnicos.map(tid => ({
          name: nombreTurno(tid),
          type: 'column',
          data: this.gfDiasCats.map(d => oeeDiaTurno(d, tid))
        }));

        // línea total (todos los turnos)
        const lineaTotal = {
          name: 'OEE total',
          type: 'line',
          data: this.gfDiasCats.map(d => oeeDiaTurno(d, null))
        };

        return [...series, lineaTotal];
      }

      if (!this.gfData?.length) return []

      // agrupar por label -> { [fecha]: {oee, teo, A,P,Q, ok} }
      const byLabel = new Map()
      for (const r of this.gfData) {
        const dia = r.fecha || 'Total'
        if (!byLabel.has(r.label)) byLabel.set(r.label, new Map())

        const oee = (r.oee != null)
        ? Number(r.oee)
        : ((Number(r.disponibilidad||0) * Number(r.rendimiento||0) * Number(r.calidad||0)) / 10000);

        byLabel.get(r.label).set(dia, {
          oee: this._roundPct(oee, 2),
          teo: Number(r.teoricas || r.teo || 0),
          A:   Number(r.disponibilidad ?? r.A ?? 0),
          P:   Number(r.rendimiento    ?? r.P ?? 0),
          Q:   Number(r.calidad        ?? r.Q ?? 0),
          ok:  Number(r.ok || 0),
        })
      }

      // Limitar a N entidades (p.ej. 8) para no saturar la gráfica
      const MAX_SERIES = 8
      const labelsOrdenados = Array.from(byLabel.keys()).sort((a,b) => {
        const avg = m => {
          const vs = Array.from(m.values()).map(x => x.oee);
          return vs.length ? vs.reduce((s,n)=>s+n,0)/vs.length : 0;
        };
        return avg(byLabel.get(b)) - avg(byLabel.get(a));
      });
      const top = labelsOrdenados.slice(0, MAX_SERIES);
      const otros = labelsOrdenados.slice(MAX_SERIES);

      // series barras para top
      const seriesBarras = top.map(label => {
        const mapa = byLabel.get(label);
        const data = this.gfDiasCats.map(d => (mapa.get(d)?.oee) ?? 0);
        return { name: label, type: 'column', data };
      });
      // (Opcional) colapsar “Otros” en una sola serie
      if (otros.length) {
        const mapaSum = new Map(), mapaTeo = new Map();
        for (const lbl of otros) {
          for (const [dia, v] of byLabel.get(lbl).entries()) {
            mapaSum.set(dia, (mapaSum.get(dia)||0) + (v.oee * v.teo));
            mapaTeo.set(dia, (mapaTeo.get(dia)||0) + v.teo);
          }
        }
        const data = this.gfDiasCats.map(d => {
          const teo = mapaTeo.get(d)||0;
          if (!teo) return 0;
          return this._roundPct((mapaSum.get(d)||0) / teo, 0);
        });
        seriesBarras.push({ name: 'Otros', type: 'column', data });
      }

      // línea OEE total ponderado por teóricas por día
      const linea = this.gfDiasCats.map(d => {
        const delDia = this.gfData.filter(x => (x.fecha || 'Total') === d)
        const sumTeo = delDia.reduce((s,x)=> s + (Number(x.teoricas ?? x.teo ?? 0)), 0)
        if (!sumTeo) return 0
        const w = k => delDia.reduce((s,x)=> s + (Number((x[k] !== undefined ? x[k] : x[k.toUpperCase()])) * Number(x.teoricas ?? x.teo ?? 0)), 0) / sumTeo
        const A = w('disponibilidad'), P = w('rendimiento'), Q = w('calidad')
        return (A * P * Q) / 10000
      })

      return [
        ...seriesBarras
      ]
    },

    // Opciones de Apex iguales al look&feel existente
      chartOptionsGF () {
        const soloDia = this.gf.agruparPor === 'dia';
        return {
          chart: { stacked:false, toolbar:{ show:true } },
          legend: { position:'top', show: !soloDia },   // 👈 oculta leyenda en “Por día”
          plotOptions: { bar: { columnWidth:'45%', dataLabels:{ position:'top' } } },
          dataLabels: {
            enabled:true,
            formatter: v => `${Number(v ?? 0).toFixed(2)}%`,   // ⬅️ 0 decimales
            offsetY:-10, style:{ fontSize:'11px' }
          },
          stroke: { width: soloDia ? [0,3] : [0] }, // ⬅️ si no es por día, no hay línea
          xaxis: { categories: this.gfDiasCats, labels: { rotate:-45 } },
          yaxis: [{ max:100, min:0, tickAmount:5, labels: { formatter: v => `${Number(v ?? 0).toFixed(2)}%` }, title:{ text:'OEE (%)' } }],
          tooltip: { y:{ formatter: v => `${Number(v ?? 0).toFixed(2)}%` } }, // ⬅️ 0 decimales
          colors: this._palette()
        }
      },
      ...mapState({        
        nombreEmpresa: 'nombreEmpresa',
      }),
      filtrosActivos () {
        const f = this.gf || {}
        let n = 0
        if (Array.isArray(f.idAreas) && f.idAreas.length) n++
        if (Array.isArray(f.idMaquinasIns) && f.idMaquinasIns.length) n++
        if (f.desde) n++
        if (f.hasta) n++
        return n
      },
      realizarPeticionGF () {
        return !!(this.gf.desde && this.gf.hasta)
      },
      realizarPeticion() {
        return !(
          this.filtros.idMaquinaIns == null ||
          this.filtros.idMaquinaIns <= 0 ||
          this.filtros.fecha == null ||
          this.filtros.turno == null ||
          this.filtros.turno <= 0
        );
      },
      resumenGF () {
        const rows = (this.gfData || []).filter(r => Number(r.teoricas) >= 0);
        if (!rows.length) {
          return { ok:0, teo:0, disp:0, rend:0, cali:0, oee:0, segParoProg:0, segParoNP:0,
                  esperadas:0, noOk:0, delta:0 };
        }
        const sum = k => rows.reduce((s,r)=> s + Number(r[k] || 0), 0);
        const segParoProg = sum('segParoProg');
        const segParoNP   = sum('segParoNP');
        const sumTeo = sum('teoricas');
        const sumOk  = sum('ok');
        const sumNoOk = sum('noOk');
        const delta = sumOk - sumTeo;

        const w = k => {
          const t = rows.reduce((s,r)=> s + Number(r.teoricas||0), 0);
          if (!t) return 0;
          return rows.reduce((s,r)=> s + Number(r[k]||0) * Number(r.teoricas||0), 0) / t;
        };

        // ⬇️ Promedio ponderado del OEE que ENVÍA el back
        const oeeBack = w('oee');

        // Dejamos A/P/Q sólo informativos (por si los quieres mostrar)
        const A = w('disponibilidad');
        const P = w('rendimiento');
        const Q = w('calidad');

        // Fallback si el EP no manda 'oee'
        const oeeCalc = this.sinDisponibilidad ? (P*Q)/100 : (A*P*Q)/10000;
        const oee = oeeBack > 0 ? oeeBack : oeeCalc;

        return {
          ok: sumOk, teo: sumTeo, disp: A, rend: P, cali: Q, oee,
          segParoProg, segParoNP,
          esperadas: sumTeo, noOk: sumNoOk, delta,
        };
      },

      // 👉 ÚNICA fuente de verdad para los cards
      kpisActuales () {
      if (this.modoDatos === 'GraficaFiltros') {
        const r = this.resumenGF;
        return {
          oee: r.oee, disp: r.disp, rend: r.rend, cali: r.cali,
          paroProg: r.segParoProg, paroNP: r.segParoNP,
          // 👇 para los 4 cards del periodo
          esperadas: r.esperadas,
          ok: r.ok,
          noOk: r.noOk,
          delta: r.delta,
        };
      }
        // fallback a la vista clásica
        const r = this.response?.resumen || this.response?.Resumen || {};
        return {
          oee: Number(r.oee ?? r.OEE ?? 0),
          disp: Number(r.disponibilidad ?? r.Disponibilidad ?? 0),
          rend: Number(r.rendimiento ?? r.Rendimiento ?? 0),
          cali: Number(r.calidad ?? r.Calidad ?? 0),
          paroProg: Number(r.segundosParoProgramado ?? r.SegundosParoProgramado ?? 0),
          paroNP: Number(r.segundosParoNoProgramado ?? r.SegundosParoNoProgramado ?? 0),
        };
      },
      gfDataOrdenada () {
        // ordena por OEE desc
        return [...this.gfData].sort((a,b) => b.oee - a.oee)
      },
      minutesLeft () { return Math.floor(this.remainingMs / 60000) },
      secondsLeft () { return Math.floor((this.remainingMs % 60000) / 1000) },
      timeFormatted () {
        return `${this.pad(this.minutesLeft)}:${this.pad(this.secondsLeft)}`
      },
      progress () {
        if (!this.totalMs) return 0
        return ((this.totalMs - this.remainingMs) / this.totalMs) * 100
      },

      fullStyle() {
        return {
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          zIndex: 2001,
          background: this.$vuetify?.theme?.dark ? '#121212' : '#fff',
          padding: '16px',
          overflow: 'auto'
      }
    },
    turnoSeleccionado() {
      if (!this.filtros.turno) return {};
      return this.turnos.find(t => t.idTurno === this.filtros.turno) || {};
    },
    
    maquinaSeleccionadaNombre() {
      if (!this.filtros.idMaquinaIns) return '';
      const inst = this.instancias.find(i => i.idMaquinaIns === this.filtros.idMaquinaIns);
      return inst ? this.nombreMaquina(inst) : '';
    }
  },

  methods: {
    _roundPct(v, dec = 2) { return Number(Number(v ?? 0).toFixed(dec)); },
    _areaMetaForRow (r) {
      // 1) si el back ya mandó área, úsala
      if (r.idArea || r.area) {
        return { idArea: r.idArea || r.area, nombreArea: r.area || r.labelArea || r.nombreArea || String(r.idArea||r.area) }
      }

      // 2) por id de instancia tal cual
      if (r.key && this.instById?.has(String(r.key))) return this.instById.get(String(r.key))

      // 3) por label de la fila
      const lbl = String(r.label || r.maquina || '').trim().toLowerCase()
      if (lbl && this._instByLabel?.has(lbl)) return this._instByLabel.get(lbl)

      // 4) por nombre “crudo”
      const name = String(r.nombre || '').trim().toLowerCase()
      if (name && this._instByName?.has(name)) return this._instByName.get(name)

      // 5) por código (si el back mandó algo parecido)
      const code = String(r.codigo || r.clave || r.tag || r.machineCode || '').trim().toLowerCase()
      if (code && this._instByCode?.has(code)) return this._instByCode.get(code)

      return null
    },
    _toYMD (v) {
      if (!v) return null
      if (typeof v === 'string') return v.slice(0,10)
      const d = v instanceof Date ? v : new Date(v)
      return isNaN(d) ? null : d.toISOString().slice(0,10)
    },
    _rebuildGfDataFromCache () {
      const d0 = this._toYMD(this.gf.desde)
      const d1 = this._toYMD(this.gf.hasta)

      const dias = Array.from(this.gfCache.entries())
        .filter(([f]) => !d0 || !d1 || (f >= d0 && f <= d1))   // 👈 compara 'YYYY-MM-DD' vs 'YYYY-MM-DD'
        .sort(([a],[b]) => a.localeCompare(b))

      const modo = this.gf.agruparPor || 'maquina'
      const out = []

      for (const [fecha, rowsDia] of dias) {
        if (modo === 'maquina' || modo === 'dia') {
          for (const r of rowsDia) out.push({ ...r, fecha })
          continue
        }
        if (modo === 'area') {
          const acc = new Map()
          for (const r of rowsDia) {
            const meta = this._areaMetaForRow(r) || {}
            const nombreArea = (r.area ?? r.labelArea ?? meta.nombreArea ?? '—') || '—'
            // preserva "0" como id válido y normaliza a string
            const idAreaRaw = (r.idArea ?? meta.idArea ?? nombreArea)
            const idArea = idAreaRaw != null ? String(idAreaRaw) : String(nombreArea)

            if (!acc.has(idArea)) acc.set(idArea, { label:nombreArea, teo:0, ok:0, A:0, P:0, Q:0, segPP:0, segNP:0 });
            const a = acc.get(idArea);
            const teo = Number(r.teoricas||0);
            a.teo += teo; a.ok += Number(r.ok||0);
            a.A   += Number(r.disponibilidad||0) * teo;
            a.P   += Number(r.rendimiento||0)    * teo;
            a.Q   += Number(r.calidad||0)        * teo;
            a.segPP += Number(r.segParoProg||0);
            a.segNP += Number(r.segParoNP||0);
            
          }
          for (const [idArea, a] of acc) {
            const A = a.teo ? a.A/a.teo : 0
            const P = a.teo ? a.P/a.teo : 0
            const Q = a.teo ? a.Q/a.teo : 0
            const oee = this.sinDisponibilidad ? (P*Q)/100 : (A*P*Q)/10000
            out.push({ fecha, key:idArea, label:a.label, teoricas:a.teo, ok:a.ok, disponibilidad:A, rendimiento:P, calidad:Q, oee,segParoProg: a.segPP, segParoNP:a.segNP })
          }
          continue
        }
      }

      this.gfData = out
    },
    _buildOeeParams ({ desde, hasta }) {
      const qs = new URLSearchParams();
      if (desde) qs.append('desde', desde);
      if (hasta) qs.append('hasta', hasta);
      (this.gf.idAreas || []).forEach(id => qs.append('idAreas', id));
      (this.gf.idMaquinasIns || []).forEach(id => qs.append('idMaquinaIns', id));
      qs.append('agruparPor', 'maquina');
      qs.append('porDia', 'true');
      qs.append('porTurno', 'true');        // 👈 IMPORTANTE
      qs.append('sinDisponibilidad', this.sinDisponibilidad);
      qs.append('desConParosNP', this.desConParosNP);
      qs.append('usarApoyoV1ParaPonderados', 'true');
      qs.append('descontarNoOkPorArticulo', 'true');
      qs.append('_', Date.now());
      return qs.toString();
    },

    _normalizeRows(rows, fallbackFecha = null) {
      const pickFecha = (r) => {
        const k = Object.keys(r||{}).find(
          k => /^(fecha|day|dia|date|fechaDia|fecha_dia|periodo|periodoDia)$/i.test(k)
        )
        const v = k ? r[k] : null
        if (!v) return fallbackFecha
        if (typeof v === 'string') return v.slice(0,10)
        if (v instanceof Date)     return v.toISOString().slice(0,10)
        const m = String(v).match(/\d{4}-\d{2}-\d{2}/)
        return m ? m[0] : fallbackFecha
      }

      return (rows || []).map(r => {
        // 🔑 id consistente de instancia de máquina
        const idInst = r.idMaquinaIns ?? r.idInstancia ?? r.idMaquina ?? r.idMaquinaINS ?? r.id ?? r.key

        return {
          fecha: pickFecha(r),
          turnoId: r.turnoId ?? r.TurnoId ?? r.turno ?? null,
          turnoNombre: r.turnoNombre ?? r.TurnoNombre ?? null,
          // 👇 usamos SIEMPRE el id de instancia como key
          key: String(idInst ?? '—'), // <- SIEMPRE id de instancia como key
          // 👇 nombre visible (si viene)
          label: r.label ?? r.nombre ?? r.maquina ?? r.area ?? '—',
          // meta de área si el back lo manda
          idArea: r.idArea ?? r.IdArea ?? r.areaId ?? null,
          area:   r.area   ?? r.nombreArea ?? r.Area ?? null,
          segParoProg: Number(
            r.segundosParoProgramado ?? r.SegundosParoProgramado ??
            r.paroProgramadoSeg ?? r.segParoProg ?? 0
          ),
          segParoNP: Number(
            r.segundosParoNoProgramado ?? r.SegundosParoNoProgramado ??
            r.segundosParo ?? r.SegundosParo ?? r.paroNoProgramadoSeg ??
            r.segParoNP ?? 0
          ),
          oee: Number(r.oee ?? r.OEE ?? 0),
          disponibilidad: Number(r.disponibilidad ?? r.A ?? 0),
          rendimiento:    Number(r.rendimiento    ?? r.P ?? 0),
          calidad:        Number(r.calidad        ?? r.Q ?? 0),
          ok:       Number(r.ok ?? r.piezasOk ?? r.piezasOkTotales ?? 0),
          noOk:     Number(r.noOk ?? r.nok ?? r.piezasNoOk ?? r.piezasNOK ?? r.scrap ?? 0),
          teoricas: Number(r.teoricas ?? r.piezasTeoricas ?? r.piezasTeoricasTotales ?? 0),
        }
      })
    },

    _sleep (ms) { return new Promise(r => setTimeout(r, ms)); },

    async startOeeLongPoll () {
      // validaciones rápidas
      if (!this.gf.hasta) return;
      if (!this.gf.desde) this.gf.desde = this.gf.hasta; // rango 1 día si falta

      // cancelar corrida anterior
      this.stopOeeLongPoll();

      // arma la lista de días
      const d0 = new Date(this.gf.desde);
      const d1 = new Date(this.gf.hasta);
      const days = [];
      for (let d = new Date(d0); d <= d1; d.setDate(d.getDate()+1)) {
        days.push(new Date(d).toISOString().slice(0,10));
      }

      this.gfData = [];                 // limpiamos acumulado
      this.lpLoading = true;
      this.lpProgress = { done: 0, total: days.length };

      // AbortController para poder cancelar
      this.lpAbort = new AbortController();

      // usaremos un Set para deduplicar (fecha|key)
      const seen = new Set();

      try {
        for (let i = 0; i < days.length; i++) {
          // si nos cancelaron, salimos
          if (this.lpAbort?.signal?.aborted) break;

          const fecha = days[i];
          const params = this._buildOeeParams({ desde: fecha, hasta: fecha })

          // IMPORTANTE: usa la MISMA base que ya te funciona con Axios
          const { data } = await axios.get(`/OEECalculos/OEEAgrupado?${params}`, {
            signal: this.lpAbort.signal
          });

          const rowsRaw = Array.isArray(data?.items) ? data.items
                        : Array.isArray(data) ? data : [];
          const rows = this._normalizeRows(rowsRaw, fecha);
          this.gfCache.set(fecha, rows)
          this._rebuildGfDataFromCache()

          // progreso y pausa de ~2s entre días
          this.lpProgress.done = i + 1;
          if (i < days.length - 1) await this._sleep(2000);
        }
      } catch (err) {
        if (err?.name !== 'CanceledError' && err?.name !== 'AbortError') {
          console.error('Long-poll error', err);
        }
      } finally {
        this.lpLoading = false;
        this.lpAbort = null;
      }
    },

    stopOeeLongPoll () {
      try { this.lpAbort?.abort(); } catch {}
      this.lpAbort = null;
      this.lpLoading = false;
    },

    ensureGFSelectedMachine () {
      const id = this.filtros?.idMaquinaIns
      if (!id) return
      const set = new Set(this.gf.idMaquinasIns || [])
      set.add(id)
      this.gf.idMaquinasIns = Array.from(set)
    },
    syncDesdeConFiltroGeneral (fecha) {
      const f = this._toYMD(fecha)
      this.gf.desde = f
      if (!this.gfHastaTouched) this.gf.hasta = f
      if (this.gf.hasta && this.gf.desde && this.gf.hasta < this.gf.desde) {
        this.gf.hasta = this.gf.desde
      }
    },
    onHastaChanged () {
      this.gfHastaTouched = true
      this.gf.hasta = this._toYMD(this.gf.hasta)
      if (this.gf.desde && this.gf.hasta && this.gf.hasta < this.gf.desde) {
        this.gf.hasta = this.gf.desde
      }
      if (this.modoDatos === 'GraficaFiltros' && this.realizarPeticionGF) {
        this.startOeeLongPoll()
      }
    },
    _avg (arr) {
      const v = arr.filter(n => Number.isFinite(+n))
      if (!v.length) return 0
      return v.reduce((a,b)=>a+ +b,0)/v.length
    },
    _palette () {
      // paleta base (coincide razonablemente con la que usas: azul, verde, naranja, etc.)
      return [
        '#1E88E5','#43A047','#FB8C00','#8E24AA','#00ACC1',
        '#F4511E','#3949AB','#6D4C41','#7CB342','#039BE5'
      ]
    },
    nf (n) { return Number(n ?? 0).toLocaleString() },
    pf (n) { return `${Number(n ?? 0).toFixed(2)}%` },
    tfmt (seg = 0) {
      const s = Math.max(0, Math.floor(Number(seg) || 0))
      const hh = String(Math.floor(s/3600)).padStart(2,'0')
      const mm = String(Math.floor((s%3600)/60)).padStart(2,'0')
      const ss = String(s%60).padStart(2,'0')
      return `${hh} : ${mm} : ${ss}`
    },
    nombreMaquina: m => `[${m.nombre}] - ${m.marca} ${m.modelo}`,
    getAreas () {
      this.loadingAreas = true
      axios.get('/Areas')
        .then(res => this.areas = res.data || [])
        .catch(console.error)
        .finally(() => this.loadingAreas = false)
    },
    async obtenerGraficaFiltros () {
      if (!this.realizarPeticionGF) return
      this.loadingGF = true
      try {
        const qs = new URLSearchParams()
        const { idAreas = [], idMaquinasIns = [], desde, hasta, agruparPor = 'dia' } = this.gf
        if (desde) qs.append('desde', desde)
        if (hasta) qs.append('hasta', hasta)
        idAreas.forEach(id => qs.append('idAreas', id))
        idMaquinasIns.forEach(id => qs.append('idMaquinaIns', id))
        if (agruparPor !== 'dia') qs.append('agruparPor', agruparPor) // 👈 solo si NO es día
        qs.append('porDia', 'true')   // principal
        qs.append('porTurno', 1);               // 👈 también aquí
        qs.append('porDia', 1)               // <- para que vengan días
        qs.append('sinDisponibilidad', this.sinDisponibilidad)
        qs.append('desConParosNP', this.desConParosNP)
        qs.append('usarApoyoV1ParaPonderados', true)   // fuerza el modo corregido del back
        qs.append('descontarNoOkPorArticulo', true)
        qs.append('_', Date.now())
        const { data } = await axios.get(`/OEECalculos/OEEAgrupado?${qs.toString()}`)
        const rows = Array.isArray(data?.items) ? data.items
                  : Array.isArray(data) ? data
                  : []

        //const tieneFecha = rows.some(r => r.fecha || r.day || r.Fecha)

        // encuentra la key de fecha aunque cambie el nombre (fecha, Fecha, dia, day, date, fechaDia, etc.)
        const pickFecha = (r) => {
        const k = Object.keys(r).find(
          k => /^(fecha|day|dia|date|fechaDia|fecha_dia|fecha_calculo|fechaProduccion|fechaRegistro|fecha_inicio|fecha_fin|periodo|periodoInicio|periodoDia)$/i.test(k)
        );
        const v = k ? r[k] : null;
        if (!v) return null;
        // normaliza: Date | 'YYYY-MM-DD...' -> 'YYYY-MM-DD'
        try {
        // si viene ISO, corta; si viene Date, formatea
        if (typeof v === 'string') return v.slice(0, 10);
        if (v instanceof Date) return v.toISOString().slice(0, 10);
        } catch(e) {}
        // último recurso: extrae YYYY-MM-DD con regex
        const m = String(v).match(/\d{4}-\d{2}-\d{2}/);
        return m ? m[0] : null;
        };
        const tieneFecha = rows.some(r => !!pickFecha(r));

        this.gfData = rows.map(r => ({
          fecha:  (tieneFecha ? pickFecha(r) : 'Total'),
          key:    r.key ?? r.id ?? r.label ?? r.maquina ?? r.area ?? '—',
          label:  r.label ?? r.nombre ?? r.maquina ?? r.area ?? '—',
          oee:    Number(r.oee ?? r.OEE ?? 0),
          disponibilidad: Number(r.disponibilidad ?? r.A ?? 0),
          rendimiento:    Number(r.rendimiento ?? r.P ?? 0),
          calidad:        Number(r.calidad ?? r.Q ?? 0),
          ok:       Number(r.ok ?? r.piezasOk ?? r.piezasOkTotales ?? 0),
          noOk:     Number(r.noOk ?? r.nok ?? r.piezasNoOk ?? r.piezasNOK ?? r.malas ?? r.scrap ?? 0),
          teoricas: Number(r.teoricas ?? r.piezasTeoricas ?? r.piezasTeoricasTotales ?? 0),
          turnoId: r.turnoId ?? r.TurnoId ?? r.turno ?? null,
          turnoNombre: r.turnoNombre ?? r.TurnoNombre ?? (r.turnoId != null ? `Turno ${r.turnoId}` : null),
          segParoProg: Number(
            r.segundosParoProgramado ?? r.SegundosParoProgramado ??
            r.paroProgramadoSeg ?? r.segParoProg ?? 0
          ),
          segParoNP: Number(
            r.segundosParoNoProgramado ?? r.SegundosParoNoProgramado ??
            r.segundosParo ?? r.SegundosParo ?? r.paroNoProgramadoSeg ??
            r.segParoNP ?? 0
          ),
        }))
      } catch (e) {
        console.error(e)
        this.gfData = []
      } finally {
        this.loadingGF = false
      }
    },
    initialize() {
      this.getInstancias();
      this.getTurnos();
      const empresa = this.nombreEmpresa?.toLowerCase();
      if(empresa === "nyx") {
        this.modoDatos = "Grafica";
        this.sinDisponibilidad = true;
        this.desConParosNP = false;
      }
      if(["cazel", "cazel-tlt"].includes(empresa)) {
        this.modoDatos = "Grafica";
        this.nombreArt = false;
        this.espOcultas = true;
        this.desConParosNP = true;
      }
      // 👇 rango por defecto GF (últimos 7 días)
      //const hoy = new Date();
      //const desde = new Date(hoy); desde.setDate(hoy.getDate() - 6);
      //const fmt = d => d.toISOString().slice(0,10);
      //if (!this.gf.desde) this.gf.desde = fmt(desde);
      //if (!this.gf.hasta) this.gf.hasta = fmt(hoy);
    },
    descargarReporte() {
      if (!this.realizarPeticion) return;

      // this.downloadingReport = true;
      const datetime = moment().format("YYYYMMDDHHmmss");

      // Armamos los parámetros igual que en obtenerDatos()
      const params = new URLSearchParams();
      params.append("idMaquinaIns", this.filtros.idMaquinaIns);
      params.append("fechaRev", this.filtros.fecha);
      params.append("idTurno", this.filtros.turno);
      params.append("sinDisponibilidad", this.sinDisponibilidad);
      params.append("desConParosNP", this.desConParosNP);

      const queryString = params.toString();

      this.$utils.axios
        .downloadFile(
          `/OEECalculos/XLSHoraPorHoraV2?${queryString}`, // <-- tu nuevo EP
          "GET",
          `reporte-HpH-${datetime}.xlsx`,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
        .finally(() => {
          // this.downloadingReport = false;
        });
    },
    obtenerDatos() {
      if (!this.realizarPeticion) return;
      this.start();
      this.loading = true;
      axios
        .get(
          `/OEECalculos/HoraPorHora?idMaquinaIns=${this.filtros.idMaquinaIns}&fechaRev=${this.filtros.fecha}&idTurno=${this.filtros.turno}&sinDisponibilidad=${this.sinDisponibilidad}&desConParosNP=${this.desConParosNP}`
        )
        .then(async (response) => {
          this.response = response.data;
          await this.obtenerTcRealParaResponse();
          this.loading = false;
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading = false;
          this.restart();
        })
    },
    //método para Tc en tiempo real Jess 
    async obtenerTcRealParaResponse() {
      if (!this.response || !this.filtros.idMaquinaIns) return;
      
      try {
        const { data: tokens } = await axios.get('/SensorDatos/TokensPorMaquina', {
          params: { idMaquinaIns: this.filtros.idMaquinaIns }
        });
        
        if (!tokens || tokens.length === 0) return;
        
        const token = tokens[0];
        const moment = this.$moment || require('moment');
        
        // Usar las MISMAS fechas que OEECalculos/HoraPorHora
        const turno = this.turnos.find(t => t.idTurno === this.filtros.turno);
        if (!turno || !this.filtros.fecha) return;
        
        // Construir inicio y fin del turno seleccionado
        const fechaBase = moment(this.filtros.fecha);
        const [horaI, minI] = (turno.inicio || '00:00').split(':');
        const [horaF, minF] = (turno.fin || '23:59').split(':');
        
        let inicio = fechaBase.clone().hour(+horaI).minute(+minI).second(0);
        let fin = fechaBase.clone().hour(+horaF).minute(+minF).second(59);
        
        if (fin.isBefore(inicio)) {
          fin.add(1, 'day');
        }
        
        const params = {
          inicio: inicio.format("YYYY-MM-DD HH:mm:ss"),
          fin: fin.format("YYYY-MM-DD HH:mm:ss"),
          idMaquinaIns: this.filtros.idMaquinaIns,
          key: token,
        };
        
        const resp = await axios.get("/SensorDatos/SeriesRealtimePostgres", { params });
        const series = resp.data?.series || [];
        
        if (series.length > 0 && series[0].data && series[0].data.length > 0) {
          const datos = series[0].data;
          
          const valores = datos
            .map(punto => Number(punto.y))
            .filter(v => Number.isFinite(v) && v > 0);
          
          if (valores.length === 0) return;
          
          const valoresOrdenados = valores.slice().sort((a, b) => a - b);
          const n = valoresOrdenados.length;
          const tcRealSeg = n % 2 === 0
            ? (valoresOrdenados[n / 2 - 1] + valoresOrdenados[n / 2]) / 2  
            : valoresOrdenados[Math.floor(n / 2)];                          
          
          // Guardar en response
          if (!this.response.tcReal) {
            this.$set(this.response, 'tcReal', {});
          }
          this.response.tcReal.segundos = tcRealSeg;
          this.response.tcReal.texto = `${tcRealSeg.toFixed(1)} seg`;
          
        }
      } catch (e) {
        console.error('Error obteniendo TC Real:', e);
      }
    },



    getInstancias() {
      this.loadingInstancias = true;
      axios
        .get('/MaquinaInstancias')
        .then(res => (this.instancias = res.data))
        .catch(err => console.log(err))
        .finally(() => {
          this.loadingInstancias = false;
        });
    },
    getTurnos() {
      this.loadingTurnos = true;
      axios
        .get("/Turnos")
        .then((response) => {
          this.turnos = response.data;
        })
        .catch(console.log)
        .finally(() => {
          this.loadingTurnos = false;
        });
    },

    pad (n) { return String(n).padStart(2, '0') },

    // Inicia / reanuda
    start () {
      if (this.isRunning) return
      if (this.remainingMs <= 0) this.remainingMs = this.totalMs
      this.endAt = Date.now() + this.remainingMs
      this.isRunning = true
      this.intervalId = setInterval(this.tick, 200) // tick fino + compensación de deriva
    },

    // Pausa / detiene
    pause () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
      this.isRunning = false
    },

    // Reinicia a los minutos iniciales y se queda detenido
    reset () {
      this.pause()
      this.remainingMs = this.totalMs
    },

    // Reinicia y arranca (opcional, por si lo necesitas)
    restart () {
      this.reset()
      this.start()
    },

    tick () {
      this.remainingMs = Math.max(this.endAt - Date.now(), 0)
      if (this.remainingMs === 0) {
        this.pause()
        this.$emit('finished')
        this.obtenerDatos()
      }
    },

    // Cambiar minutos en caliente (opcional)
    setMinutes (mins) {
      this.totalMs = Math.max(0, Number(mins) || 0) * 60 * 1000
      this.reset()
    },
  },
  mounted() {
    // arma índice máquina -> área (usa lo que ya trae /MaquinaInstancias)
    this.$watch('instancias', () => {
      const byId   = new Map()
      const byName = new Map()  // nombre “crudo” (m.nombre)
      const byCode = new Map()  // algún código si existe (m.codigo || m.clave || m.tag)
      const byLabel = new Map() // cómo suele venir en la fila (intenta varios formatos)

      for (const m of (this.instancias || [])) {
        const meta = { idArea: m.idArea, nombreArea: m.nombreArea, idMaquinaIns: String(m.idMaquinaIns) }

        byId.set(String(m.idMaquinaIns), meta)

        if (m.nombre) byName.set(String(m.nombre).trim().toLowerCase(), meta)
        if (m.codigo || m.clave || m.tag) {
          const code = String(m.codigo || m.clave || m.tag).trim().toLowerCase()
          byCode.set(code, meta)
        }

        // posibles labels que el back pudiera mandar
        const lbls = new Set([
          m.nombre,
          `[${m.nombre}] - ${m.marca||''} ${m.modelo||''}`.trim(),
          `${m.marca||''} ${m.modelo||''}`.trim(),
        ].filter(Boolean).map(s => s.toLowerCase()))
        for (const s of lbls) byLabel.set(s, meta)
      }

      this.instById = new Map(
        (this.instancias || []).map(m => {
          // alias robustos para id/nombre de área
          const idArea =
            m.idArea ?? m.IdArea ?? m.areaId ?? m.AreaId ?? m.id_area ?? m.area_id ?? null
          const nombreArea =
            m.nombreArea ?? m.NombreArea ?? m.areaNombre ?? m.nombre_area ?? m.Area ?? m.area ?? null

          return [
            String(m.idMaquinaIns),
            { idArea: idArea != null ? String(idArea) : null, nombreArea: nombreArea || null }
          ]
        })
      )
      this._instByName  = new Map(
        (this.instancias || [])
          .filter(m => m?.nombre)
          .map(m => [String(m.nombre).trim().toLowerCase(), {
            idArea: m.idArea ?? m.areaId ?? null,
            nombreArea: m.nombreArea ?? m.area ?? null
          }])
      )
      this._instByCode  = new Map(
        (this.instancias || [])
          .filter(m => m?.codigo || m?.clave || m?.tag)
          .map(m => [String(m.codigo || m.clave || m.tag).trim().toLowerCase(), {
            idArea: m.idArea ?? m.areaId ?? null,
            nombreArea: m.nombreArea ?? m.area ?? null
          }])
      )
      this._instByLabel = new Map(
        (this.instancias || []).flatMap(m => {
          const candidates = new Set([
            m.nombre,
            `[${m.nombre}] - ${m.marca||''} ${m.modelo||''}`.trim(),
            `${m.marca||''} ${m.modelo||''}`.trim()
          ].filter(Boolean).map(s => s.toLowerCase()))
          return Array.from(candidates).map(k => [k, {
            idArea: m.idArea ?? m.areaId ?? null,
            nombreArea: m.nombreArea ?? m.area ?? null
          }])
        })
      )
    }, { immediate: true, deep: true })
    this.initialize()
    this.getAreas()
    if (this.filtros?.fecha) this.syncDesdeConFiltroGeneral(this.filtros.fecha)
    this.ensureGFSelectedMachine()
  },
  watch: {
    'gf.idMaquinasIns': {
      deep: true,
      handler () {
        this.gfCache.clear();
        if (this.modoDatos === 'GraficaFiltros' && this.realizarPeticionGF) {
          this.startOeeLongPoll();
        }
      }
    },
    'gf.idAreas': {
      deep: true,
      handler () {
        this.gfCache.clear();
        if (this.modoDatos === 'GraficaFiltros' && this.realizarPeticionGF) {
          this.startOeeLongPoll();
        }
      }
    },
    'gf.agruparPor': function(){ this._rebuildGfDataFromCache() },
    sinDisponibilidad(){ this._rebuildGfDataFromCache() },
    desConParosNP(){ this._rebuildGfDataFromCache() },
    'gf.desde': function(){ this._rebuildGfDataFromCache() },
    'gf.hasta': function(){ this._rebuildGfDataFromCache() },
    'filtros.idMaquinaIns'(v) {
      this.ensureGFSelectedMachine()
      // refresca si estás en la pestaña de gráfica y ya hay rango
      if (this.modoDatos==='GraficaFiltros' && this.realizarPeticionGF) this.startOeeLongPoll()
    },
    'filtros.fecha'(v) {
      this.syncDesdeConFiltroGeneral(v)
      if (this.modoDatos==='GraficaFiltros' && this.realizarPeticionGF) this.startOeeLongPoll()
    },
    minutes (m) { this.setMinutes(m) },
    modoDatos (v) {
      if (v === 'GraficaFiltros' && this.realizarPeticionGF) this.startOeeLongPoll()
      else this.stopOeeLongPoll()
    },
    //'gf.desde':  function () { if (this.modoDatos==='GraficaFiltros' && this.realizarPeticionGF) this.obtenerGraficaFiltros() },
    //'gf.hasta'(v){
    //  if (this.gf.desde && v && v < this.gf.desde) this.gf.hasta = this.gf.desde
    //},
    //'gf.agruparPor': function () { if (this.modoDatos==='GraficaFiltros' && this.realizarPeticionGF) this.obtenerGraficaFiltros() },
    //sinDisponibilidad () { if (this.modoDatos==='GraficaFiltros' && this.realizarPeticionGF) this.obtenerGraficaFiltros() },
    //desConParosNP   () { if (this.modoDatos==='GraficaFiltros' && this.realizarPeticionGF) this.obtenerGraficaFiltros() },

    // arrays: usa deep watcher
    gf: {
      deep: true,
      handler (nv, ov) {
        // si lo único que cambió fue agruparPor, no refetch
        const strip = o => JSON.stringify({ ...o, agruparPor: undefined })
        if (strip(nv) === strip(ov)) return

        if (this.modoDatos === 'GraficaFiltros' && this.realizarPeticionGF) {
          clearTimeout(this._lpDeb)
          this._lpDeb = setTimeout(() => this.startOeeLongPoll(), 250)
        }
      }
    }
  },
  beforeDestroy () {
    this.stopOeeLongPoll();
    if (this.intervalId) clearInterval(this.intervalId)
  },
};
</script>
<style>
/* agrega al <style scoped> */
.bar-wrap{ height:12px; background:#eef2f7; border-radius:999px; overflow:hidden; }
.bar{ height:100%; background:linear-gradient(90deg,#81c784,#4caf50); }
.gf-filtros .v-input { min-width: 200px; }
.apex-wrap{ position:relative; min-height:320px; }
.click-blocker{
  position:absolute; inset:0; z-index:5;
  /* transparente, sólo bloquea interacción */
  background: transparent;
  pointer-events: auto;
}
.lockable { position: relative; }
.ui-lock-overlay{
  position: absolute; inset: 0; z-index: 10;
  background: rgba(255,255,255,.001); /* transparente pero bloquea */
  pointer-events: all;
}
/* <style scoped> */
.kpi-card{ border-radius:12px; }
.title{ line-height:1; }
.pos{ color:#2E7D32; }
.neg{ color:#E53935; }
@media (max-width: 960px){
  .kpi-sub{ display:block; } /* móvil */
}
@media (min-width: 961px){
  /* en desktop evita repetir “Total del periodo” tan grande */
  .kpi-sub{ opacity:.85; font-size:10px; }
}
/* Zona de la gráfica con panel lateral */
.apex-zone{ position: relative; }

/* Panel derecho que NO modifica el ancho de la gráfica */
.side-kpis{
  position: absolute;
  top: 8px;
  right: 8px;
  width: 620px;      /* ajusta si lo quieres más angosto/ancho */
  z-index: 2;        /* sobre la carta pero sin bloquear la gráfica */
  pointer-events: none; /* que no “tape” la interacción con la gráfica */
}
.side-kpis .v-card{ pointer-events: auto; } /* pero sí permite clicks dentro del panel */

/* Helpers de visibilidad: ya usamos d-none / d-md-block de Vuetify */
</style>